import { Link } from "react-router-dom"
import { BarChart3 } from "lucide-react"
import { usePageTitle } from "@/hooks/use-page-title"

export default function ReportsHubPage() {
  usePageTitle("Reports Hub")

  return (
    <main className="min-h-screen bg-slate-100">
      <header className="bg-slate-800 text-white">
        <div className="px-6 py-6">
          <h1 className="text-2xl font-semibold">Reports Hub</h1>
          <p className="text-slate-400 mt-1">Select a module to get started</p>
        </div>
      </header>

      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Link
            to="/engagements"
            className="group bg-white rounded-lg border border-slate-200 p-6 hover:border-slate-300 hover:shadow-md transition-all duration-200 min-h-[180px]"
          >
            <div className="w-12 h-12 rounded-lg bg-blue-500 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform">
              <BarChart3 className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-base font-semibold text-slate-800 mb-1 group-hover:text-slate-900">Engagement Reports</h2>
            <p className="text-sm text-slate-500 leading-relaxed">View financial reports, hours, and time entries for all engagements</p>
          </Link>
        </div>
      </div>
    </main>
  )
}
